import { NovaPluginIds } from "panels/controls/PluginAccessPanel/constants"
import { GenericTryPluginModal } from "./GenericTryPluginModal"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { selectUserID } from "user/profile/selectors"
import { createPanoramaFlight } from "features/pubsub/entityActions/flights/panorama"
import { SampleDataFlightKey } from "@nova/constants"
import { hideGlobalModal } from "runlevel/actions"

export const TryPanoramaModal = () => {
    const dispatch = useAppDispatch()
    const userId = useAppSelector(selectUserID)

    const createSamplePanoramaFlight = () => {
        if (!userId) return

        dispatch(
            createPanoramaFlight({
                data: {
                    createdBy: {
                        userId,
                    },
                },
                context: {
                    sampleDataFlightKey: SampleDataFlightKey.pano1,
                },
            })
        )

        dispatch(hideGlobalModal())
    }

    return (
        <GenericTryPluginModal
            pluginId={NovaPluginIds.Panorama}
            title="Try Panorama for free"
            subtitle="Capture every angle."
            body="Our panorama tool ensures no perspective is overlooked, providing a comprehensive view for you and your team beyond traditional images or video."
            footer="Use pre-loaded sample data to experience this powerful tool."
            buttonTitle="Use Sample Data"
            onButtonClick={createSamplePanoramaFlight}
        />
    )
}
